exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".diamond[data-v-ea0ff974]{cursor:-webkit-grab;display:inline-block;width:50px;height:25px;background-color:#272727;color:#fff}.nosel[data-v-ea0ff974]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
